import { Field } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';
import { NoAuthorization } from './noAuthorization.model';
import { BasicAuth } from './basicAuth.model';
import { GlobalMetadataJsonModel } from '../global-metadata/global-metadata.json.model';

export interface LearnObjectTypeDescriptions {
  label: string
  metadata: GlobalMetadataJsonModel[]
}

export class NlpSetting {
  @Field()
  public nlpFeedbackLanguage!: string;

  @Field()
  public nlpFeedbackCorrectnessThreshold!: number;
}

export class Theme {
  @Field()
  public primaryColor!: string;

  @Field()
  public secondaryColor!: string;

  @Field()
  public tertiaryColor!: string;

  @Field()
  public placeholderColor!: string;

  @Field()
  public hoverColor!: string;

  @Field()
  public drawColor!: string;

  @Field()
  public drawHighlightColor!: string;

  @Field()
  public compareSolutionsBgColor!: string;
}

export class SubjectConfig {
  @Field()
  public subjectId!: string;

  @Field()
  public fontId!: string;
}

export class PlayerSetting {
  @Field()
  public selfJudgementPopup!: boolean;

  @Field()
  public dontKnowBtn!: boolean;

  @Field()
  public readoutExerciseText!: boolean;

  @Field()
  public randomOrderOfTestSequences!: boolean;

  @Field()
  public textSelectionEnabled!: boolean;

  @Field()
  public emptyAnswerWarningPopup!: boolean;

  @Field()
  public checkAnswerPopup!: boolean;

  @Field()
  public showNoteButton!: boolean;

  @Field()
  public showBottomPart!: boolean;

  @Field()
  public showSelfRating!: boolean;

  @Field()
  public showExerciseSequenceTabs!: boolean;

  @Field()
  public allowedFrontendOrigins!: string[];

  @Field()
  public hideExerciseHeadline!: boolean;

  @Field()
  public theme!: Theme;

  @Field()
  public maxTries!: number;

  @Field()
  public retryMode!: string;

  @Field()
  public hideResetExerciseButton!: boolean;

  @Field()
  public showCompletionIcons!: boolean;

  @Field()
  public subjectConfigs!: SubjectConfig[];

  @Field()
  public tabLetters!: boolean;

  @Field()
  public disableExerciseFeedback!: boolean;

  @Field()
  public flattenExercises!: boolean;

  @Field()
  public footerInfo!: string;
}

export class ConsumerJsonModel extends JsonApiModel {
  public static override readonly type = 'consumers';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public authorization!: NoAuthorization | BasicAuth;

  @Field()
  public availableClasses!: string[];

  @Field()
  public baseColor!: string;

  @Field()
  public changedBy!: string;

  @Field()
  public competenceTree!: string;

  @Field()
  public consumerMetadata!: GlobalMetadataJsonModel[];

  @Field()
  public description!: string;

  @Field()
  public kiService!: boolean;

  @Field()
  public learnObjectTypeDescriptions!: LearnObjectTypeDescriptions[];

  @Field()
  public name!: string;

  @Field()
  public nlpSettings!: NlpSetting;

  @Field()
  public playerFilesFolder!: string;

  @Field()
  public playerSettings!: PlayerSetting;

  @Field()
  public updated!: Date;

  @Field()
  public url!: string;

  @Field()
  public urlPlaceholders!: string;

  @Field()
  public version!: number;
}
